export default __webpack_public_path__ + "static/media/bg-site.6e12de72.png";